import moment from 'moment-timezone';

export function nowAtTimezone(timezone) {
    return moment.tz(timezone).toDate();
}

export function dateAtTimezone(date, timezone) {
    return moment.tz(date, timezone).toDate();
}

export function formatDateTime(dateString) {
    if (!dateString) return "";
    return new Date(dateString).toLocaleString();
}